import { Link } from "react-router-dom";
import logo from "../assest/logo1.png";
function Footer() {
  return (
    <footer style={{padding: "60px 20px", background: "#000000",position: "relative",overflow: "hidden",
        color: "#ccc"}}>
      {/* Neon Glow Background */}
      <div style={{position: "absolute",top: "-100px",right: "-100px",width: "300px",height: "300px",       background: "rgba(0,255,234,0.15)", borderRadius: "50%", filter: "blur(150px)",zIndex: 1}}
      ></div>

      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div className="row">

          {/* Column 1 — Logo & About */}
          <div className="col-md-4 mb-4 text-start">
            <Link to="/">
              <img src={logo} alt="Logo" style={{ width: "180px", marginBottom: "20px" }} />
            </Link>
            <h3 style={{ color: "#00ffea", marginBottom: "15px", fontSize: "22px" }}>
              About Us
            </h3>

            <p style={{ lineHeight: "1.7", fontSize: "15px" }}>
              Click Informatics provides high-quality digital solutions at affordable prices. 
              We ensure maximum client satisfaction with measurable results.
            </p>
          </div>

          {/* Column 2 — Services */}
          <div className="col-md-4 mb-4 text-start">
            <h3 style={{ color: "#00ffea", marginBottom: "20px", fontSize: "22px" }}>
              Our Services
            </h3>

            <div className="row">
              <div className="col-6">
                <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                  <li>Web Designing</li>
                  <li>E-Marketing</li>
                  <li>Training</li>
                  <li>Retention</li>
                  <li>Point of Sales</li>
                </ul>
              </div>

              <div className="col-6">
                <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                  <li>App Development</li>
                  <li>Bulk SMS</li>
                  <li>Koha LMS</li>
                  <li>E-Commerce</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Column 3 — Quick Links */}
          <div className="col-md-4 mb-4 text-start">
            <h3 style={{ color: "#00ffea", marginBottom: "20px", fontSize: "22px" }}>
              Quick Links
            </h3>
            <div className="row">
              <div className="col-md-6">
                <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                  <li><Link to="/" style={linkStyle}>Home</Link></li>
                  <li><Link to="/services" style={linkStyle}>Services</Link></li>
                  <li><Link to="/about" style={linkStyle}>About</Link></li>
                  <li><Link to="/contact" style={linkStyle}>Contact</Link></li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                  <li><Link to="/" style={linkStyle}>Home</Link></li>
                  <li><Link to="/services" style={linkStyle}>Services</Link></li>
                  <li><Link to="/about" style={linkStyle}>About</Link></li>
                  <li><Link to="/contact" style={linkStyle}>Contact</Link></li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div 
        style={{
          marginTop: "40px",
          textAlign: "center",
          paddingTop: "20px",
          borderTop: "1px solid rgba(0,255,234,0.2)",
          color: "#777"
        }}
      >
        © 2025 Click Informatics. All Rights Reserved.
      </div>
    </footer>
  );
}

const linkStyle = {
  color: "#ccc",
  textDecoration: "none",
  fontSize: "16px",
  transition: "0.3s",
  cursor: "pointer",
  display: "block"
};

export default Footer;
